import { createSlice } from "@reduxjs/toolkit";
import { FailedUserFetchResponse } from "../../../constants/error_messages";
import { IS_VALID_CUSTOMER_TAG } from "../../../constants/reducer_names";
import { isValidCustomerTag } from "../../api/customerTag";

const initialState = {
  customerTagList: [] as any,
  customrTagListConstant: "",
  isUpdateCustomer: false,
  isValidloading: false,
  responseError: {
    hasError: false,
    errorMessage: "",
  },
} as any;

const isValidCustomerTagSlice = createSlice({
  name: IS_VALID_CUSTOMER_TAG,
  initialState,
  reducers: {
    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(isValidCustomerTag.pending, (state) => {
      state.isValidloading = true;
    });
    builder.addCase(isValidCustomerTag.fulfilled, (state) => {
      state.isValidloading = false;
    });
    builder.addCase(isValidCustomerTag.rejected, (state, { payload }: any) => {
      state.responseError.hasError = true;
      state.responseError.errorMessage =
        payload?.message ?? FailedUserFetchResponse;
      state.isValidloading = false;
    });
  },
});
export const isValidCustomerTagAction = isValidCustomerTagSlice.actions;
export default isValidCustomerTagSlice.reducer;
